function VipNav({ dimensions, col = '#F4B400' }) {
  const baseXml = `
    <svg width="${dimensions || 24}" height="${dimensions || 24}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.5" y="1.5" width="21" height="21" rx="4" stroke="${col}" stroke-width="1.5" />
      <path d="M6 16V10.5L9.5 13L12 9.5L14.5 13L18 10.5V16H6Z" fill="${col}" />
      <rect x="6" y="16" width="12" height="2" rx="1" fill="${col}" />
    </svg>
  `;

  return baseXml;
}

export default VipNav;
